import React from 'react';
import {useProject} from "../../../providers/ClientProjectProvider";
import {useAuth} from "../../../providers/AuthProvider";
import {useOutletContext} from "react-router-dom";

const ScopingCallBanner = ({ className = '' }) => {
    const {project, isProjectUpdating, postUpdate} = useProject();
    const {auth} = useAuth();
    const {onRequest, isDisabled} = useOutletContext();

    if (!project.isFixedFee() || project.hasConfirmedProjectScope()) {
        return null
    }
    return (
        <div className={`bg-blue-500 py-2.5 flex gap-10 justify-center items-center flex-col sm:flex-row ${className}`}>
            <p className="flex items-center gap-2">
                <span className="fa-stack text-white">
                    <i className="far fa-calendar fa-stack-2x text-[26px]"></i>
                    <i className={TB.mapClass("fas text-[11px] mt-[2px] fa-stack-1x", {
                        "fa-exclamation": !project.hasCompletedProjectScopeCall(),
                        "fa-check": project.hasCompletedProjectScopeCall(),
                    })}/>
                </span>

                <span className="font-semibold text-lg text-white flex-grow">
                    {project.hasCompletedProjectScopeCall() ? 'Scoping Call Completed': 'Scoping Call Required to Continue'}
                </span>
            </p>

            <button
                onClick={async () => {
                    let confirm = await project.confirmScopingCallRequest();

                    if (confirm) {
                        await onRequest(async () => {
                            return postUpdate({scope_call_requested_at: new Date()})
                        })

                        return TB.toast("Request Submitted! We will be reaching out shortly.")
                    }
                }}
                disabled={project.hasRequestedProjectScopeCall() || isDisabled || isProjectUpdating}
                className={TB.mapClass('rounded-md border-transparent font-semibold text-base px-8 py-1.5', {
                    'btn-primary': !project.hasRequestedProjectScopeCall(),
                    'bg-white': project.hasRequestedProjectScopeCall()
                })}
            >
                {project.hasCompletedProjectScopeCall() ? "Pending Final Scope" : (!project.hasRequestedProjectScopeCall() ? "Schedule Call" : "Call Pending")}
            </button>
        </div>
    )

};

export default ScopingCallBanner;